import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class BusinessModeService {
  private businessModeSource = new BehaviorSubject<boolean>(true); // default true
  businessMode$ = this.businessModeSource.asObservable();

  setBusinessMode(value: boolean) {
    this.businessModeSource.next(value);
  }

  getBusinessModeValue(): boolean {
    return this.businessModeSource.value;
  }
}
